// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_OszsW","after-pay-info":"after-pay-info_MPUWN","msg":"msg_6-7V6","title-img":"title-img_L8CmZ","sub-title":"sub-title_oym2v"};